import React from 'react';
import { Progress } from 'antd';
import styled from 'styled-components';

import { SeoScore, STATUS_COLOR } from './seoScore';

const Container = styled.div`
  .headline {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 18px;
  }

  li {
    display: flex;
    gap: 8px;
    padding: 3px 0;
  }

  .dot {
    flex: none;
    margin-top: 5px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
  }

  .label {
    font-weight: 600;
    flex: none;
  }

  .detail {
    color: #666;
  }
`;

/**
 * The rule-by-rule breakdown. Every check says what to do about it rather than just
 * passing or failing, so the panel is usable without knowing SEO conventions.
 */
const SeoChecklist = ({ result }: { result: SeoScore }) => (
  <Container>
    <div className="headline">
      <Progress
        type="circle"
        percent={result.score}
        width={54}
        strokeColor={STATUS_COLOR[result.status]}
        format={value => <span style={{ fontSize: 14 }}>{value}</span>}
      />
      <div>
        <div style={{ fontWeight: 600 }}>Metadata score</div>
        <div style={{ color: '#888', fontSize: 12 }}>
          Tag completeness only. Content quality scoring is separate.
        </div>
      </div>
    </div>
    <ul>
      {result.checks.map(check => (
        <li key={check.key}>
          <span className="dot" style={{ background: STATUS_COLOR[check.status] }} />
          <span className="label">{check.label}</span>
          <span className="detail">{check.detail}</span>
        </li>
      ))}
    </ul>
  </Container>
);

export default SeoChecklist;
